import { useQuery } from "@tanstack/react-query"

import clientSDK from '../../App/ClientSDK';

type Permissions = {
    has_access_to_settings: boolean;
    is_visible_in_calendar: boolean;
    is_visible_online: boolean;
    "customer.all_data.show": boolean;
    "settings.account.manage": boolean;
    "hr.users.manage": boolean;
    "hr.absences.manage": boolean;
    "hr.punchclock.manage": boolean;
    "hr.time.manage": boolean;
    "hr.targets.manage": boolean;
    "marketing.manage": boolean;
    "settings.activities.manage": boolean;
    "settings.register.manage": boolean;
    "settings.webshop.manage": boolean;
    "settings.online_payment.manage": boolean;
    "settings.shop.manage": boolean;
  }
  
type PersonData = {
    uuid: string;
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    is_visible_in_calendar: boolean;
    is_visible_online: boolean;
    avatar: string;
    is_active: boolean;
    establishment_id: number;
    out_of_service_at: string | null;
    permissions: Permissions;
    agb_code: string | null;
    is_cabine: boolean;
    starts_at: string | null;
    has_to_punch: boolean;
  }
  
  export interface ApiResponse {
    data: PersonData;
  }

  const baseUrl = 'hr/persons'

  const getPersonData = async (personUuid: string): Promise<PersonData> => {
    const response = await clientSDK
      .instance()
      .get<ApiResponse>(`${baseUrl}/${personUuid}`)
    return response.data.data
  }
  
  export const useGetPersonDataQuery = (uuid: string) => {
    return useQuery({
      queryKey: ['person-data', uuid],
      queryFn: () => getPersonData(uuid),
    })
  }
